module.exports = __webpack_public_path__ + "static/covid-c7f79849034b22cdaca7967b2463ab66.jpg";